import { createContext } from "react";

// The slot whose field has focus; every spot it takes on the page is tinted.
export const HighlightedSlotContext = createContext<string | undefined>(
  undefined
);
